import { useQuery } from '@apollo/client/react';
import { Col, Divider, Flex, Row } from 'antd';
import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { useCommunitySettings } from '@guuru/community-web';
import { usePageTitle } from '@guuru/react-hooks';
import { Loading } from '@guuru/react-loading';
import Bio from './Bio';
import Comments from './Comments';
import Details from './Details';
import Moments from './Moments';
import Name from './Name';
import Opinions from './Opinions';
import Photo from './Photo';
import GET_EXPERT_PROFILE from './queries/GetPersistedExpertProfile';

const Profile = function () {
  const { expertId, partnerId } = useParams();
  const { search } = useLocation();
  const { partnerName } = useCommunitySettings();

  const { data, loading } = useQuery(GET_EXPERT_PROFILE, {
    variables: {
      partnerId: partnerId!,
      expertId: expertId!,
    },
  });
  const expert = data?.community?.expert;

  usePageTitle(
    `${expert?.name} – ${partnerName} Community Member Profile | GUURU`,
    `Meet ${expert?.name}, a trusted member of the ${partnerName}
    community sharing advice, product insights, and real experiences with other
    customers.`,
  );

  if (loading) {
    return <Loading />;
  }

  if (!expert) {
    return <Navigate to={`../guurus${search}`} />;
  }

  return (
    <Flex wrap justify="center" gap={48} style={{ width: '100%' }}>
      <Col xs={{ flex: '450px' }} md={{ flex: '2' }} lg={{ flex: '450px' }}>
        <Row>
          <Photo expert={expert} />
        </Row>
      </Col>
      <Col xs={24} md={{ flex: '3' }}>
        <Flex vertical gap={24}>
          <Name expert={expert} />
          <Bio expert={expert} />
        </Flex>
        <Divider />
        <Details expert={expert} />
        <Comments expert={expert} />
        <Opinions mentions={expert.mentions} />
        <Divider />
        <Moments moments={expert.moments} />
      </Col>
    </Flex>
  );
};

export default Profile;
